import { render, staticRenderFns } from "./px-navbar.vue?vue&type=template&id=b997369c&scoped=true&"
import script from "./px-navbar.vue?vue&type=script&lang=ts&"
export * from "./px-navbar.vue?vue&type=script&lang=ts&"
import style0 from "./px-navbar.vue?vue&type=style&index=0&id=b997369c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b997369c",
  null
  
)

export default component.exports